import { render, staticRenderFns } from "./encartSelection.vue?vue&type=template&id=1b493bab"
import script from "./encartSelection.vue?vue&type=script&lang=js"
export * from "./encartSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports